import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

import heroshape from '../../images/slider/shape-bg.svg';
import heroshape2 from '../../images/slider/shape-1.svg';
import heroshape3 from '../../images/slider/shape-2.svg';
import hero from '../../images/slider/slide-1.jpg';
import hero2 from '../../images/slider/slide-2.jpg';

const ClickHandler = () => {
    window.scrollTo(10, 0);
};

const Hero2 = (props) => {
    const { t } = useLanguage();

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'ease-in-out',
    };

    return (
        <section className={"" + props.hclass}>
            <Slider {...settings}>
                <div>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero})` }}>
                        <div className="container-fluid">
                            <div className="slide-content">
                                <div className="slide-sub-title">
                                    <h2>
                                        {t('hero.slide1').split(t('hero.slide1highlight'))[0]}
                                        <span className="text">{t('hero.slide1highlight')}</span>
                                        {t('hero.slide1').split(t('hero.slide1highlight'))[1]}
                                    </h2>
                                </div>
                                <div className="slide-btns">
                                    <Link to="/about" onClick={ClickHandler} className="theme-btn-s2">{t('hero.btn')}</Link>
                                </div>
                            </div>
                        </div>
                        <div className="bg-shape"><img src={heroshape} alt="Veteriner Onaylı Takviyeler" /></div>
                        <div className="shape-1"><img src={heroshape2} alt="Kedi Fip Vitamini" /></div>
                        <div className="shape-3"><img src={heroshape3} alt="Köpek Eklem Sağlığı" /></div>
                    </div>
                </div>
                <div>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero2})` }}>
                        <div className="container-fluid">
                            <div className="slide-content">
                                <div className="slide-sub-title">
                                    <h2>{t('hero.slide2h1')} <br /> <span>{t('hero.slide2h2')} </span> <span className="text">{t('hero.slide2h3')} </span>{t('hero.slide2h4')}</h2>
                                </div>
                                <div className="slide-sub-title">
                                    <p>{t('hero.slide2p')}</p>
                                </div>
                                <div className="slide-btns">
                                    <Link to="/about" onClick={ClickHandler} className="theme-btn-s2">{t('hero.btn')}</Link>
                                </div>
                            </div>
                        </div>
                        <div className="bg-shape"><img src={heroshape} alt="Evcil Hayvan Sağlığı" /></div>
                        <div className="shape-1"><img src={heroshape2} alt="Bağışıklık Güçlendirici" /></div>
                        <div className="shape-3"><img src={heroshape3} alt="Mutlu Kedi Köpek" /></div>
                    </div>
                </div>
            </Slider>
        </section>
    );
};

export default Hero2;
